<block-ui>
  <div class="page page--login page--full-height">
    <!-- PRODUCT TITLE & DESCRIPTION -->
    <div class="page__container">
      <!-- LOGIN FORM -->
      <div class="page__right-panel">
        <div class="form">
          <div class="form__header">
            <!-- logo -->

            <div class="card__logo card__logo--center">
              <img src="assets/images/logo-gt.png" alt="Globaltrack" />
            </div>

            @if (!forgotPasswordFormEnabled) {
              <div>
                <!-- page details -->
                <div class="form__details mt-5 text-center text-dark">
                  <h4 class="form__title">{{ 'login.signInWith' | transloco }}</h4>
                  <!--<p class="form__description"></p>-->
                </div>

                <!-- SSO -->
                <app-social-login (signInWithGoogle)="signInWithGoogle($event)"
                  (signInWithMicrosoft)="signInWithMicrosoft($event)"></app-social-login>

                <div class="divider-or">
                  <h5>{{ 'login.or' | transloco }}</h5>
                </div>
              </div>
            }
          </div>

          @if (!forgotPasswordFormEnabled) {
            <div class="form__body">
              <app-login-form [inlineErrorMessage]="inlineErrorMessage"
                (toggleForgotPasswordForm)="toggleForgotPassword($event)">
              </app-login-form>
            </div>
          } @else {
            <div class="form__body pt-3">
              <app-forgot-password-form
                (toggleForgotPasswordForm)="toggleForgotPassword($event)"></app-forgot-password-form>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</block-ui>